import type {
  SortOrder,
  WithdrawalListOrderBy,
  WithdrawalRequestStatus,
} from "Infrastructure/Api/Api";

export const WITHDRAWAL_APPROVALS_QUERY_KEYS = {
  all: ["WITHDRAWAL_APPROVALS"] as const,
  list: (
    offset?: number,
    limit?: number,
    status?: WithdrawalRequestStatus | null,
    searchQuery?: string,
    orderBy?: WithdrawalListOrderBy,
    sortOrder?: SortOrder,
  ) =>
    [
      ...WITHDRAWAL_APPROVALS_QUERY_KEYS.all,
      "LIST",
      offset,
      limit,
      status,
      searchQuery,
      orderBy,
      sortOrder,
    ] as const,
  detail: (withdrawalRequestID: string) =>
    [
      ...WITHDRAWAL_APPROVALS_QUERY_KEYS.all,
      "DETAIL",
      withdrawalRequestID,
    ] as const,
} as const;
